import Table from '@codegouvfr/react-dsfr/Table';
import React from 'react';

export const PolitiqueConfidentialite = () => {
  return (
    <div className="max-w-[1200px] mx-auto px-6 py-10 bg-white">
      <h1>Politique de protection des données personnelles de Mon Activité Apprentissage « MAP »</h1>
      <p className="text-sm text-[#666] mb-8">Version 1 du 04/05/2026</p>

      <section className="mb-8">
        <h2>Introduction</h2>
        <p>
          Le présent site (<a
          href={'https://ofa-map-apprentissage.francecompetences.fr'}>https://ofa-map-apprentissage.francecompetences.fr</a>),
          appelé Mon Activité Apprentissage « MAP
          »
          a pour objet de permettre le dépôt des enquêtes relatives à leur comptabilité analytique par les Centres de
          Formation d’Apprentis (CFA) ;
        </p>
        <p>
          La présente politique a pour objectif de décrire en toute transparence les règles de mise œuvre des
          traitements
          de données à caractère personnel réalisés par France compétences dans le cadre de Mon Activité Apprentissage «
          MAP »,
          d’encadrer la conformité de ces traitements et de garantir le respect des droits des personnes concernées.
        </p>
        <p>
          Les textes de références de cette politique sont le RGPD (Règlement Général pour la Protection des Données),
          la loi dite « Informatique et Libertés » du 6 janvier 1978 et la loi du 20 juin 2018 relative à la protection
          des données personnelles. Les notions utilisées dans cette politique sont définies dans le RGPD, notamment les
          notions de traitement, de données personnelles ou données à caractère personnel, de personnes concernées et de
          responsable de traitement.
        </p>
        <p>
          France compétences est attachée au respect de la vie privée et à la protection des données personnelles des
          utilisateurs de Mon Activité Apprentissage « MAP ». Nous nous engageons à définir et appliquer les mesures
          adéquates afin de garantir la sécurité des données personnelles. Afin de veiller à la bonne application de ces
          règles,
          France compétences a désigné un Délégué à la Protection des Données ou Data Protection Officer (DPO) qui est
          le relai
          privilégié sur ces sujets (voir paragraphe 1.2).
        </p>
      </section>

      <section className="mb-8">
        <h2>1. Le responsable de traitement</h2>

        <h3>1.1. Identité et coordonnées du responsable de traitement</h3>
        <p>
          France compétences est une institution nationale publique créée par la loi n° 2018-771 du 5 septembre 2018
          pour la liberté de choisir son avenir professionnel (décret paru au J.O. du 30 décembre 2018), immatriculée
          sous le numéro SIRET 130 024 565 00025. France compétences est responsable de traitement et détermine à ce
          titre les finalités et les moyens des traitements mis en œuvre par le biais de Mon Activité Apprentissage «
          MAP »
        </p>
        <p>
          <strong>Adresse du siège social :</strong> France compétences, 6 rue du Général Audran – 92400 Courbevoie
        </p>
        <p><strong>Téléphone :</strong> 01 81 69 01 40</p>

        <h3>1.2. Identité et coordonnées du Data Protection Officer (DPO) désigné par le responsable de traitement</h3>
        <p>
          France compétences a désigné un Délégué à la Protection des Données dit « DPD » ou Data Protection Officer dit
          « DPO », dont les missions sont notamment de :

          <ul className="list-disc pl-6">
            <li>Veiller à la conformité des traitements au regard de la législation et réglementation en vigueur en
              matière de protection des données personnelles et notamment des exigences du RGPD au sein de France
              compétences ;
            </li>
            <li>Piloter la conformité de France compétences en bénéficiant des moyens nécessaires pour mener à bien sa
              mission ;
            </li>
            <li>Tenir un registre des traitements de données à caractère personnel mis en œuvre par France compétences
              ;
            </li>
            <li>Accompagner les équipes lors de la mise en œuvre des traitements, et dans ce cadre, informer et
              sensibiliser les collaborateurs ;
            </li>
            <li>Répondre aux demandes d’exercice des droits des utilisateurs de Mon Activité Apprentissage « MAP » ;
            </li>
            <li>Être l’interlocuteur spécialisé et privilégié auprès de la Commission Nationale de l’Informatique et des
              Libertés (CNIL) et des personnes concernées par un traitement de données à caractère personnel.
            </li>
          </ul>
        </p>
        <p>Vous pouvez contacter le DPO de France compétences :</p>
        <p><strong>Par courriel :</strong> dpo@francecompetences.fr</p>
        <p>
          <strong>Par courrier :</strong><br />
          DPO France compétences,<br />
          HAAS AVOCATS<br />
          6, rue de Saint-Pétersbourg, 75008 PARIS
        </p>
      </section>

      <section className="mb-8">
        <h2>2. Pourquoi utilisons-nous vos données personnelles ?</h2>
        <p>
          France compétences traite vos données à caractère personnel pour les finalités suivantes :
        </p>

        <Table
          data={[
            [
              'Dépôt d’enquêtes relatives à leur comptabilité analytique par les Centres de formation d’apprentis (CFA) (également appelées « déclarations »)',
              'L’information des collaborateurs des CFA concernant la procédure de remontée de la comptabilité analytique des CFA',
              'L’exécution de notre mission d’intérêt public résultant de l’article L.6123-5 6° du code du travail',
            ],
            [
              '',
              'L’analyse et le suivi de la comptabilité analytique des CFA',
              'L’obligation légale résultant de l’article L. 6123-5 6° du code du travail et de l’arrêté du 29 juillet 2020 fixant les règles de mise en œuvre de la comptabilité analytique au sein des organismes de formation qui dispensent des formations par apprentissage en application de l\'article L. 6231-4 du code du travail',
            ],
            [
              '',
              'L’élaboration de statistiques',
              'L’exécution de notre mission d’intérêt public résultant des articles L. 6123-5 3° et 6° du code du travail',
            ],
            [
              'Gestion de Mon Activité Apprentissage « MAP » et des comptes utilisateurs',
              'Administration de Mon Activité Apprentissage « MAP » et des comptes d’utilisateurs',
              'L’exécution de notre mission d’intérêt public résultant des articles L. 6123-5 3°, 6° et 10° du code du travail',
            ],
            [
              'Suivi et évaluation de l’apprentissage',
              'Envoi de communications générales relatives à l’apprentissage à destination des collaborateurs des CFA',
              'L’exécution de notre mission d’intérêt public résultant de l’article L. 6123-5 7° du code du travail',
            ],
            ['',
              'Gestion et suivi des enquêtes relatives à l’apprentissage, portant notamment sur la qualité, le coût de revient et, de manière plus générale, sur le déroulement des formations en CFA.',
              'L’exécution de notre mission d’intérêt public résultant des articles L.6123-5 7° du code du travail',
            ],
          ]
          }
          headers={[
            'Finalités',
            'Sous-finalités',
            'Base légale',
          ]}
        />


        <h3>En savoir plus sur les finalités du traitement : </h3>
        <p>Mon Activité Apprentissage « MAP » revêt les finalités suivantes :</p>
        <ul className="list-disc pl-6">
          <li>Le dépôt d’enquêtes relatives à leur comptabilité analytique par les CFA (également appelées «
            déclarations
            »)
          </li>
        </ul>
        <p>
          Ces enquêtes, exigées dans le cadre du dispositif prévu par l’article L. 6123-5 6° du code du travail et
          l’arrêté du 29 juillet 2020, sont déposées par les CFA sur Mon Activité Apprentissage « MAP » via leur(s)
          compte(s) utilisateur(s).
        </p>
        <p>Les données des collaborateurs inscrits sur Mon Activité Apprentissage « MAP » peuvent également être
          utilisées
          par France compétences pour leur envoyer des communications ou des enquêtes relatives à l’apprentissage dans
          le
          cadre de sa mission découlant de l’article L.6123-5 7° du code du travail. </p>

      </section>

      <section className="mb-8">
        <h2>3. Collecte et origine des données</h2>
        <p>
          France compétences procède, selon les traitements, à une collecte directe ou indirecte de données à caractère
          personnel.
          France compétences traite les données à caractère personnel de manière loyale et licite. Par le biais de Mon
          Activité Apprentissage « MAP » et le Portail de France compétences qui est le point d’entrée de connexion vous
          permettant de créer un compte et de vous connecter sur « MAP »., France compétences limite la collecte des
          données personnelles au strict nécessaire, soit aux catégories de données suivantes :
        </p>

        <h3>3.1. S’agissant des collaborateurs des organismes (CFA) susceptibles de déposer des enquêtes sur Mon
          Activité
          Apprentissage « MAP » (et ayant à cette fin un compte utilisateur)</h3>

        <p>Les données de ces collaborateurs, traitées dans le cadre de la gestion de Mon Activité Apprentissage « MAP
          et des comptes utilisateurs, sont les suivantes : </p>

        <ul className="list-disc pl-6">
          <li>Identité de l’utilisateur de Mon Activité Apprentissage « MAP » et du Portail de France compétences (ex :
            nom(s), prénom(s), courriel professionnel),
          </li>
          <li>Vie professionnelle (numéro de téléphone professionnel, fonction, organisme de rattachement),</li>
          <li>Données de connexion (identifiant, mot de passe, cookies, adresse IP).</li>
        </ul>

        <p>Il s’agit généralement de données nécessaires à la connexion sur Mon Activité Apprentissage « MAP permettant
          aux collaborateurs de déposer les enquêtes et les dossiers demandés dans le cadre des finalités mentionnées
          ci-dessus.</p>

        <p>Dans le cadre de la remontée des comptabilités analytiques, il est précisé que ces données personnelles
          peuvent être indirectement collectées par France compétences dès lors que les utilisateurs de Mon Activité
          Apprentissage « MAP » ont la possibilité de créer eux-mêmes d’autres comptes utilisateurs au bénéfice des
          collaborateurs d’un même organisme. </p>

        <h3>3.2. S’agissant des données des collaborateurs exerçant au sein des CFA (hors collaborateurs susceptibles de
          déposer des enquêtes et ayant à cette fin un compte utilisateur)</h3>

        <p>Dans le cadre du dépôt des enquêtes relatives aux niveaux de prise en charge des contrats d’apprentissage et
          du dépôt des d’enquêtes relatives à leur comptabilité analytique par les CFA, les utilisateurs de l’Extranet
          peuvent nous transmettre les données personnelles de tiers, tels que les collaborateurs des CFA (représentant
          légal, administrateurs et délégataires) </p>

        <p>Ainsi, France compétences reçoit dans le cadre de cette collecte indirecte la communication des données
          d’identité et des coordonnées professionnelles suivantes :</p>

        <ul className="list-disc pl-6">
          <li>Identité du collaborateur (ex : nom(s), prénom(s), courriel professionnel, signaturedu représentant légal
            ou du délégataire),
          </li>
          <li>Vie professionnelle (numéro de téléphone professionnel, fonction, organisme de rattachement).</li>
        </ul>

        <p>Ces données ne donnent pas lieu à la création d’un compte utilisateur et sont traitées par France compétences
          afin de lui permettre d’exercer ses missions statutaires, d’une part, de collecte des comptabilités
          analytiques des organismes de formation ayant une activité d’apprentissage.</p>

        <h3>3.3. Données susceptibles d’être protégées au titre du secret des affaires</h3>
        <p>
          Dans le cadre de la transmission de la comptabilité analytique des CFA, France compétences est susceptible de
          collecter des données protégées par le secret des affaires. Conformément à l’article L.151-7 du code de
          commerce, nous vous informons que cette collecte est requise par l’article L. 6123-5 6° du code du travail
          ainsi que par l’article 4 l’arrêté du 21 juillet 2020 fixant les règles de mise en œuvre de la comptabilité
          analytique au sein des organismes de formation qui dispensent des formations par apprentissage en application
          de l'article L. 6231-4 du code du travail.
        </p>
        <p>En tout état de cause, France compétences a pris les mesures nécessaires pour garantir la confidentialité des
          données transmises et analysées sur la plateforme Mon Activité Apprentissage « MAP ».</p>
      </section>

      <section className="mb-8">
        <h2>4. Destinataires</h2>
        <p>
          Les données collectées sur Mon Activité Apprentissage « MAP » de France compétences sont exclusivement
          réservées à l’usage de France compétences, et ne font l’objet d’aucune cession à des tiers. Elles sont
          nécessaires au bon suivi des dossiers et ne sont accessibles qu’aux personnes habilitées au sein de France
          compétences.
        </p>
        <p>Les données personnelles sont susceptibles d’être transmises à des sous-traitants qui traitent les données
          uniquement pour le compte et selon les instructions de France compétences et notamment à :</p>
        <ul className="list-disc pl-6">
          <li>THALES SERVICES NUMERIQUES SAS, en qualité d’opérateur technique de Mon Activité Apprentissage « MAP »,
            société par actions simplifiées à associé unique, immatriculée au RCS de Versailles sous le numéro 428 677
            124, dont le siège social est situé 19-21 Avenue Morane Saulnier, 78140 Vélizy-Villacoublay ;
          </li>
          <li>CEGEDIM, en qualité d’hébergeur et de fournisseur de messagerie électronique/de mailing, société anonyme,
            immatriculée au RCS de Nanterre No B 350 422 622, dont le siège social est situé 137 rue d’Aguesseau, 92100
            Boulogne-Billancourt ;
          </li>
          <li>Les prestataires de contrôle de service fait des opérations programmées par le FPSPP, substitué par France
            compétences ;
          </li>
          <li>Les prestataires de contrôle de service fait des opérations programmées par le FPSPP avec le soutien du
            Fonds social européen, substitué par France compétences ;
          </li>
          <li>Les prestataires d’assistance à maîtrise d’ouvrage pour le pilotage et le suivi de contrôle de service
            fait des opérations programmées par le FPSPP substitué par France compétences.
          </li>
        </ul>

        <p>Par ailleurs, aux fins de gestion et de contrôle des financements accordés aux organismes, France compétences
          peut transmettre les données personnelles relatives aux enquêtes aux destinataires suivants : Cour des
          comptes, Cour des comptes européenne, Inspection générale des finances (IGF), Inspection générale des affaires
          sociales (IGAS), Direction générale des Finances publiques (DGFIP) et Délégation générale à l'Emploi et à la
          Formation professionnelle (DGEFP).</p>

        <p>Des sous-traitants (prestataires) peuvent être désignés, dans le respect des règles de la commande publique,
          pour contrôler les dossiers et/ou analyser la comptabilité analytique des CFA. </p>

        <p>Des clauses spécifiques portant sur la protection des données et des engagements relatifs à la sécurité des
          données à caractère personnel qui pourraient leur être transmises dans ce cadre et à leur destruction après
          utilisation sont systématiquement incluses dans les contrats de prestation.</p>

        <p>Enfin, France compétences est susceptible de transmettre les données collectées, s’il y a lieu, aux
          juridictions concernées, médiateurs, experts-comptables, commissaires aux comptes, avocats ou huissiers.</p>
      </section>

      <section className="mb-8">
        <h2>5. Transferts de données en dehors de l’Union européenne</h2>
        <p>
          France compétences s’engage à ne pas transférer vos données en dehors de l’Union Européenne.
        </p>
        <p>Dans l’hypothèse où France compétences devrait le faire, vous en serez immédiatement informé. Nous vous
          indiquerons les mesures prises afin de contrôler ce transfert et s’assurer du respect de la confidentialité de
          leurs données.</p>
      </section>

      <section className="mb-8">
        <h2>6. Durée de conservation des données</h2>
        <p>
          Conformément à la législation et aux réglementation applicables, les données à caractère personnel ne sont
          conservées par France compétences sous une forme permettant l’identification des personnes que pendant une
          durée qui n'excède pas la durée nécessaire aux finalités pour lesquelles elles sont collectées et traitées, à
          savoir :
        </p>
        <ul className="list-disc pl-6">
          <li>Pour la gestion de Mon Activité Apprentissage « MAP » et des comptes d’Utilisateurs</li>
          <li>Pour les enquêtes relatives à la détermination du niveau de prise en charge (NPEC) et les enquêtes
            relatives à la comptabilité analytique des CFA
          </li>
          <li>Pour informer les collaborateurs des CFA sur la procédure de remontée analytique ainsi que sur
            l’apprentissage (communications générales)
          </li>
          <li>Pour la gestion et le suivi des enquêtes relatives à l’apprentissage, portant notamment sur la qualité, le
            coût de revient et, de manière plus générale, sur le déroulement des formations en CFA
          </li>
          <li>Pour les données collectées à partir des cookies : nous vous invitons à voir la politique des cookies</li>
        </ul>

        <p>Vos données à caractère personnel constituent des archives publiques. À ce titre, France compétences n’est
          pas autorisée à les archiver ou à les détruire sans l’accord préalable du Service Interministériel des
          Archives de France.</p>

        <p>Une procédure de conventionnement avec le Service Interministériel des Archives de France est en cours afin
          de déterminer les durées de conservation de vos données à caractère personnel et les conditions de leur
          archivage ou suppression.</p>

      </section>

      <section className="mb-8">
        <h2>7. Information et droits des personnes concernées</h2>

        <h3>7.1. Information des personnes concernées</h3>
        <p>
          Préalablement à la mise en œuvre de ses traitements, France compétences informe les personnes concernées –
          notamment les collaborateurs susceptibles de déposer des enquêtes au sein des organismes – conformément aux
          articles 13 et 14 du RGPD.
        </p>
        <p>Concernant l’Extranet, l’information est notamment dispensée aux personnes concernées par le biais de la
          présente politique de confidentialité et des mentions disponibles sur nos formulaires d’inscription et nos
          communications par courriel.</p>

        <h3>7.2. Vos droits</h3>
        <p>Conformément à la législation et à la règlementation en vigueur (notamment, la loi n° 78-17 du 6 janvier 1978
          relative à l’informatique, aux fichiers et aux libertés, modifiée par la loi n° 2018-493 du 20 juin 2018
          relative à la protection des données personnelles et le Règlement applicable au 25 mai 2018 – RGPD), les
          personnes concernées bénéficient des droits suivants : </p>
        <ul className="list-disc pl-6">
          <li>Droit d’accès (<a
            href={'https://www.cnil.fr/fr/reglement-europeen-protection-donnees/chapitre3#Article15'}>article 15
            RGPD</a>), de rectification (<a
            href={'https://www.cnil.fr/fr/reglement-europeen-protection-donnees/chapitre3#Article16'}>article 16
            RGPD</a>), de mise à jour, de
            complétude de vos données (<a href={'https://www.cnil.fr/fr/comprendre-vos-droits'}>en savoir plus</a>)
          </li>
          <li>Droit de verrouillage ou d’effacement de vos données à caractère personnel (<a
            href={'https://www.cnil.fr/fr/reglement-europeen-protection-donnees/chapitre3#Article17'}>article 17
            RGPD</a>), lorsqu’elles
            sont inexactes, incomplètes, équivoques, périmées, ou dont la collecte, l’utilisation, la communication ou
            la conservation est interdite (<a
              href={'https://www.legifrance.gouv.fr/affichTexteArticle.do%3Bjsessionid%3DF99FCEDCD62590E5C611B9152B030E99.tplgfr21s_2?idArticle=LEGIARTI000033219719&cidTexte=LEGITEXT000006068624&dateTexte=20180207'}>en
              savoir plus</a>)
          </li>
          <li>Droit à la limitation du traitement de vos données (<a
            href={'https://www.cnil.fr/fr/reglement-europeen-protection-donnees/chapitre3#Article18'}>article 18
            RGPD</a>)
          </li>
          <li>Droit d’opposition au traitement de vos données (<a
            href={'https://www.cnil.fr/fr/reglement-europeen-protection-donnees/chapitre3#Article21'}>article 21
            RGPD</a>
            ) (<a href={'https://www.cnil.fr/fr/comprendre-vos-droits'}>en savoir plus</a>)
          </li>
          <li>Droit à la portabilité des données que vous nous avez fournies, lorsque vos données font l’objet de
            traitements automatisés fondés sur votre consentement ou sur un contrat (<a
              href={'https://www.cnil.fr/fr/reglement-europeen-protection-donnees/chapitre3#Article20'}>article 20
              RGPD</a>)
          </li>
          <li>Droit de définir le sort de vos données après votre mort et de choisir que nous communiquions (ou non) vos
            données à un tiers que vous aurez préalablement désigné (<a
              href={'https://www.cnil.fr/fr/ce-que-change-la-loi-pour-une-republique-numerique-pour-la-protection-des-donnees-personnelles#mortnumerique'}>en
              savoir
              plus</a>). En cas de décès
            et à défaut
            d’instructions de votre part, nous nous engageons à détruire vos données, sauf si leur conservation s’avère
            nécessaire à des fins probatoires ou pour répondre à une obligation légale.
          </li>
        </ul>
        <p>
          Les personnes concernées ont également la possibilité d’introduire à tout moment une réclamation auprès de la
          Commission nationale de l’informatique et des libertés (CNIL).
        </p>

        <h3>7.3. Comment exercer vos droits ?</h3>
        <p>Pour exercer vos droits, les personnes concernées peuvent écrire au DPO de France compétences chargé du
          respect des droits des personnes :</p>
        <p><strong>Par courriel :</strong> dpo@francecompetences.fr</p>
        <p>
          <strong>Par courrier :</strong><br />
          DPO France compétences,<br />
          HAAS AVOCATS<br />
          6, rue de Saint-Pétersbourg, 75008 PARIS
        </p>

        <h3>7.4. Modalités de traitement de vos demandes d’exercice de droits par France compétences</h3>
        <p>
          Une réponse sera apportée dans les délais fixés par la législation et réglementation, étant précisé que :
        </p>
        <ul className="list-disc pl-6">
          <li>S’il s’agit d’un collaborateur d’un organisme, la demande sera directement traitée par le DPO de France
            compétences ;
          </li>
          <li>S’il s’agit d’un bénéficiaire de formation, France compétences transmettra la demande d’exercice des
            droits à l’organisme concerné. Ce dernier traitera la demande et adressera une réponse à la personne
            concernée.
          </li>
        </ul>

        <p>Afin de pouvoir traiter une demande, celle-ci doit être signée et la personne concernée doit justifier de son
          identité par tout moyen. En cas de doute raisonnable quant à l’identité de la personne, France compétences
          peut demander des informations supplémentaires et nécessaires, y compris, lorsque la situation l’exige, la
          photocopie d’un titre d’identité portant la signature de la personne.</p>

        <p>En cas d’exercice des droits, le DPO traite les données personnelles à des fins de gestion de la demande
          (civilité, nom, prénom, justificatifs d’identité, copie du titre d’identité, nature de la demande, réponse
          apportée). Ces données sont conservées pendant une durée de trois (3) ans, à l’exception de la copie du titre
          d’identité, laquelle est conservée un (1) an.</p>

      </section>

      <section className="mb-8">
        <h2>8. Les cookies</h2>
        <p>
          Conformément à l’article 82 de la Loi dite Informatique et Libertés, France compétences utilise des cookies
          visant à permettre ou à faciliter la transmission de la communication par voie électronique pour lesquels le
          recueil du consentement n’est pas obligatoire.
        </p>

        <h3>8.1. Qu’est-ce qu’un cookie ?</h3>
        <p>
          Un cookie est une information déposée sur le terminal de l’internaute (ordinateur, mobile, tablette…) par le
          serveur de Mon Activité Apprentissage « MAP ». Mon Activité Apprentissage « MAP » implante un cookie sur votre
          terminal pour enregistrer des informations relatives à votre navigation, et permet à son émetteur d’identifier
          le terminal sur lequel il est enregistré, pendant la durée de validité dudit cookie.
        </p>

        <h3>8.2. Dans quel but utilisons-nous des cookies ?</h3>
        <p>
          Mon Activité Apprentissage « MAP » de France compétences utilise uniquement des cookies nécessaires à
          l’utilisation du site : il s’agit des cookies indispensables à la navigation sur Mon Activité Apprentissage «
          MAP » qui vous permettent d’utiliser les principales fonctionnalités du site et de sécuriser votre connexion.
          Ces cookies sont exclusivement émis par France compétences.
        </p>

        <h3>8.3. Comment désactiver les cookies ?</h3>
        <p>
          Vous pouvez configurer votre navigateur afin de désactiver les cookies :
        </p>

        <ul className="list-disc pl-6">
          <li>Pour Google Chrome : <a
            href={'https://support.google.com/chrome/answer/95647?hlrm=en'}>https://support.google.com/chrome/answer/95647?hlrm=en</a>
          </li>
          <li>Pour Mozilla Firefox :
            <a
              href={'https://support.mozilla.org/en-US/kb/cookies-information-websites-store-on-your-computer'}>https://support.mozilla.org/en-US/kb/cookies-information-websites-store-on-your-computer</a>
          </li>
          <li>Pour Microsoft Edge :
            <a
              href={'https://support.microsoft.com/en-gb/help/4468242/microsoft-edge-browsing-data-and-privacy-microsoft-privacy'}>https://support.microsoft.com/en-gb/help/4468242/microsoft-edge-browsing-data-and-privacy-microsoft-privacy</a>
          </li>
          <li>Pour Opera : <a
            href={'https://help.opera.com/en/latest/security-and-privacy/#tracking'}>https://help.opera.com/en/latest/security-and-privacy/#tracking</a>
          </li>
          <li>Pour Internet Explorer :
            <a
              href={'https://support.microsoft.com/en-gb/help/17442/windows-Internet-explorer-delete-manage-cookies#'}>https://support.microsoft.com/en-gb/help/17442/windows-Internet-explorer-delete-manage-cookies#</a>
          </li>
          <li>Pour Apple Safari : <a
            href={'https://support.apple.com/guide/safari/manage-cookies-and-website-data-sfri11471/mac'}>https://support.apple.com/guide/safari/manage-cookies-and-website-data-sfri11471/mac</a>
          </li>
        </ul>

        <p>Nous vous rappelons qu’en désactivant l’utilisation de ces cookies, il se peut que vous ne puissiez plus
          bénéficier de certaines fonctionnalités de Mon Activité Apprentissage « MAP ». </p>

        <h3>8.4. Quelle est la durée de conservation des cookies ?</h3>
        <p>Les cookies sont conservés sur votre ordinateur pendant la durée de votre session sur Mon Activité
          Apprentissage « MAP ».</p>
      </section>

      <section className="mb-8">
        <h2>9. Sécurité des données personnelles</h2>
        <p>
          En sa qualité de responsable de traitement, France compétences détermine et met en œuvre les mesures
          techniques et organisationnelles appropriées et nécessaires à la sécurité et à la confidentialité des données
          à caractère personnel pour éviter notamment tout accès par un tiers non autorisé et prévenir toute perte,
          altération ou divulgation non autorisée de données.
        </p>
        <p>Conformément à l’article 32 du RGPD, France compétences et ses sous-traitants s’engagent à respecter la
          sécurité et la confidentialité de vos données.</p>

        <p>Dans ce cadre, France compétences a défini une politique stricte de sécurité des données personnelles qui
          permet notamment de :</p>
        <ul className="list-disc pl-6">
          <li>Sécuriser les postes de travail de ses collaborateurs avec des identifiants uniques et des mots de passe
            complexes et robustes conformes aux recommandations de la CNIL,
          </li>
          <li>Limiter le nombre de collaborateurs ayant accès aux fichiers contenant vos données à caractère personnel
            (gestion des droits d’accès et des habilitations),
          </li>
          <li>Recourir à des procédés de chiffrement et/ou de cryptage pour protéger tout fichier de données à caractère
            personnel entrant ou sortant du système d’information de France compétences,
          </li>
          <li>S’assurer que ses propres sous-traitants respectent la législation et la règlementation applicables en
            matière de protection des données personnelles,
          </li>
          <li>Tester et auditer régulièrement le système d’information afin d’en vérifier son niveau élevé de
            sécurité.
          </li>
        </ul>
      </section>

      <section className="mb-8">
        <h2>10. Modifications de la présente politique</h2>
        <p>
          France compétences est susceptible de modifier la présente politique de protection des données en tant que de
          besoin. Nous veillerons à ce que vous soyez informés de ces modifications par une mention spéciale sur Mon
          Activité Apprentissage « MAP » ou par un courriel d’information.
        </p>
      </section>
    </div>
  );
};